<div
  class="v-input v-input--dense theme--light v-text-field v-text-field--filled v-text-field--is-booted v-text-field--enclosed"
>
  <div class="v-input__control">
    <div class="v-input__slot">
      <div class="v-text-field__slot">
        <label [for]="name" [class]="state">{{ placeholder }}</label
        ><input
          [name]="name"
          type="text"
          (blur)="blur()"
          (focus)="focus()"
          [(ngModel)]="text"
          ng-reflect-model=""
          class="ng-untouched ng-pristine ng-valid"
        />
      </div>
      <div class="v-input__append-inner">
        <div
          id="toggleConfirmPassword"
          class="v-input__icon v-input__icon--append"
        ></div>
      </div>
    </div>
  </div>
</div>
